// apps/web/src/services/LeadFormService.js

import fetch from "auth/FetchInterceptor";

const LeadFormService = {};


// =====================================================
// LEAD FORMS - LISTAR
// =====================================================

LeadFormService.list = function () {
  return fetch({
    url: "/lead-forms",
    method: "get",
  });
};


// =====================================================
// LEAD FORMS - BUSCAR FORMULÁRIO POR ID
// =====================================================

LeadFormService.get = function (id) {
  return fetch({
    url: `/lead-forms/${id}`,
    method: "get",
  });
};


// =====================================================
// LEAD FORMS - CRIAR
// =====================================================

LeadFormService.create = function (data) {
  return fetch({
    url: "/lead-forms",
    method: "post",
    data,
  });
};


// =====================================================
// LEAD FORMS - ATUALIZAR
// =====================================================

LeadFormService.update = function (id, data) {
  return fetch({
    url: `/lead-forms/${id}`,
    method: "patch",
    data,
  });
};


// =====================================================
// LEAD FORMS - EXCLUIR
// =====================================================

LeadFormService.remove = function (id) {
  return fetch({
    url: `/lead-forms/${id}`,
    method: "delete",
  });
};


// =====================================================
// CAMPOS - ADICIONAR
// =====================================================

LeadFormService.addField = function (formId, data) {
  return fetch({
    url: `/lead-forms/${formId}/fields`,
    method: "post",
    data,
  });
};


// =====================================================
// CAMPOS - ATUALIZAR
// =====================================================

LeadFormService.updateField = function (fieldId, data) {
  return fetch({
    url: `/lead-form-fields/${fieldId}`,
    method: "patch",
    data,
  });
};


// =====================================================
// CAMPOS - EXCLUIR
// =====================================================

LeadFormService.removeField = function (fieldId) {
  return fetch({
    url: `/lead-form-fields/${fieldId}`,
    method: "delete",
  });
};


// =====================================================
// PÚBLICO - FORMULÁRIO DO JOGO
// =====================================================

LeadFormService.getPublicByGame = function (gameId) {
  return fetch({
    url: `/public/games/${gameId}/lead-form`,
    method: "get",
  });
};


// =====================================================
// PÚBLICO - ENVIAR LEAD
// =====================================================

LeadFormService.submitLead = function (data) {
  return fetch({
    url: "/public/leads",
    method: "post",
    data,
  });
};


// =====================================================
// ADMIN - LISTAR LEADS
// =====================================================

LeadFormService.listLeads = function (formId) {
  return fetch({
    url: formId
      ? `/leads?formId=${formId}`
      : "/leads",

    method: "get",
  });
};


// =====================================================
// ADMIN - BUSCAR LEAD POR ID
//
// Endpoint:
// GET /leads/:id
//
// Usado, entre outros lugares, para abrir os dados
// do participante diretamente pelo ranking River Race.
// =====================================================

LeadFormService.getLead = function (id) {
  return fetch({
    url: `/leads/${id}`,
    method: "get",
  });
};


export default LeadFormService;